import React from "react";
import "./index.scss";

export type HeaderProps = React.PropsWithChildren;

export const Header: React.FC<HeaderProps> = ({ children }) => {
  return <div className="progress-header">{children}</div>;
};
